import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, listInfo, remove } from 'kapix-components-vue3'
import blocPreviewProfilExpertComponentStoreCustom from './store.custom'

const storeName = 'blocPreviewProfilExpertComponent'
const customImplement: CustomStoreImplementationOptions = blocPreviewProfilExpertComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function blocPreviewProfilExpertComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          tags: [
            {
              id: 1,
              Nom: 'Bacon'
            },
            {
              id: 2,
              Nom: 'Pizza'
            },
            {
              id: 3,
              Nom: 'Shirt'
            },
            {
              id: 4,
              Nom: 'Keyboard'
            },
            {
              id: 5,
              Nom: 'Shirt'
            },
            {
              id: 6,
              Nom: 'Table'
            },
            {
              id: 7,
              Nom: 'Salad'
            }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          poste: undefined as Nullable<string>,
          firstName: undefined as Nullable<string>,
          enttreprise: undefined as Nullable<string>,
          image: undefined as Nullable<string | File>
        },
        $info: { tagsProfilExpertList: listInfo<Kapix.Entity.ITagsExperts>() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $tags (): WritableComputedRef<PartialEntities<Kapix.Entity.ITagsExperts>> {
        return computed({
          get: () => this.$data.tags,
          set: (value) => {
            this.$data.tags = value
            this.$emit('update:tags', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $poste (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.poste,
          set: (value) => {
            this.$data.poste = value
            this.$emit('update:poste', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $firstName (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.firstName,
          set: (value) => {
            this.$data.firstName = value
            this.$emit('update:firstName', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $enttreprise (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.enttreprise,
          set: (value) => {
            this.$data.enttreprise = value
            this.$emit('update:enttreprise', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $image (): WritableComputedRef<Nullable<string | File>> {
        return computed({
          get: () => this.$data.image,
          set: (value) => {
            this.$data.image = value
            this.$emit('update:image', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return blocPreviewProfilExpertComponentFactory(storeId)()
}

export const blocPreviewProfilExpertComponentRaw = blocPreviewProfilExpertComponentFactory()
export const blocPreviewProfilExpertComponent = () => blocPreviewProfilExpertComponentRaw() as MergeCustomStore<typeof blocPreviewProfilExpertComponentStoreCustom.instance>
